import { render, staticRenderFns } from "./InvoiceType.vue?vue&type=template&id=6aedc700&scoped=true&"
import script from "./InvoiceType.vue?vue&type=script&lang=ts&"
export * from "./InvoiceType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedc700",
  null
  
)

export default component.exports